import styled from 'foundations-theming/utils';
import { useTableCellBorderStyles, useTableStyles } from '../Table.styles';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { useTableContext } from '../TableContext';
import { CSS_SPECIFICITY } from '../../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTCell = styled.td.withConfig({
  displayName: "TableCell__StyledTCell"
})(({
  $cssStyles,
  $bordered,
  $condensed,
  $exteriorBorders
}) => {
  const {
    condensedPadding,
    defaultPadding
  } = useTableStyles();
  const tableCellBorderStyles = useTableCellBorderStyles({
    interiorBorders: $bordered,
    isHeader: false,
    exteriorBorders: $exteriorBorders
  });
  return Object.assign({}, $condensed ? condensedPadding : defaultPadding, tableCellBorderStyles, {
    hyphens: 'auto',
    overflowWrap: 'break-word',
    lineHeight: 'normal',
    verticalAlign: 'top'
  }, {
    [CSS_SPECIFICITY.OVERRIDE]: $cssStyles
  });
});
export const TableCell = props => {
  const {
    domProps,
    callbackProps,
    restProps,
    tokenProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    bordered,
    condensed,
    _exteriorBorders
  } = useTableContext();
  return /*#__PURE__*/_jsx(StyledTCell, Object.assign({}, domProps, callbackProps, restProps, {
    $bordered: bordered,
    $condensed: condensed,
    $exteriorBorders: _exteriorBorders,
    $cssStyles: cssStyles
  }));
};
TableCell.displayName = 'TableCell';